export default __webpack_public_path__ + "static/media/cark-title.efbe8d36.svg";